export default __webpack_public_path__ + "static/media/logo.ed4ed4ac.png";